import giveMyViewStillPreviewSrc1 from "public/addons/give-my-view/give-my-view-still-preview-1.jpg";
import giveMyViewStillPreviewSrc2 from "public/addons/give-my-view/give-my-view-still-preview-2.jpg";

import { AddOnPromotionPage } from "../components/AddOnPromotionPage";
import { GIVE_MY_VIEW_ADDON } from "../constants";
import { giveMyViewPrimaryActionHandler } from "../addOnActionHandlers";

export const GiveMyViewPage = () => {
  return (
    <AddOnPromotionPage
      {...GIVE_MY_VIEW_ADDON}
      videoId="E33HUApUn_Q"
      videoTitle="Give My View - Digital community consultation surveys"
      previewImages={[
        { src: giveMyViewStillPreviewSrc1, alt: "Preview" },
        { src: giveMyViewStillPreviewSrc2, alt: "Preview" },
      ]}
      onPrimaryActionClick={giveMyViewPrimaryActionHandler}
      primaryActionText="View"
    />
  );
};
